import { getAxiosInstance } from "./axiosInstance";

const createCertificateAdmin = (data) => {
  const http = getAxiosInstance();

  return http.post("/api/certificate/admin/create/", data);
};

const createCertificateTeamLead = (data) => {
  const http = getAxiosInstance();

  return http.post("/api/certificate/teamlead/create/", data);
};

const createCertificateTeamExecutive = (data) => {
  const http = getAxiosInstance();

  return http.post("/api/certificate/executive/create/", data);
};

// Update Certificate Admin
const updateCertificateAdmin = (data) => {
  const http = getAxiosInstance();

  return http.post("/api/certificate/admin/update/", data);
};

// List Cetificate Admin
const getCertificateAdminList = (params = {}) => {
  const http = getAxiosInstance();

  return http.get("/api/certificate/admin/list/", {
    params,
  });
};

// Update Certificate Team Lead
const updateCertificateTeamLead = (data) => {
  const http = getAxiosInstance();

  return http.post("/api/certificate/teamlead/update/", data);
};

// List Cetificate Team Lead
const getCertificateTeamLeadList = (params = {}) => {
  const http = getAxiosInstance();

  return http.get("/api/certificate/team/list/", {
    params,
  });
};

// ---------------------------------------------
// Activate Certificate Team Member
// ---------------------------------------------

const activateCertificateTeamMember = (data) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/certificate/team/activate/",
    data
  );
};

// ---------------------------------------------
// Deactivate Certificate Team Member
// ---------------------------------------------

const deactivateCertificateTeamMember = (data) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/certificate/team/deactivate/",
    data
  );
};

// Update Certificate Executive
const updateCertificateExecutive = (data) => {
  const http = getAxiosInstance();

  return http.post("/api/certificate/executive/update/", data);
};

// List Cetificate Executive
const getCertificateExecutiveList = (params = {}) => {
  const http = getAxiosInstance();

  return http.get("/api/certificate/team/list/", {
    params,
  });
};

// =====================================================
// CERTIFICATE ACCESS SCOPE APIs
// =====================================================

// ---------------------------------------------
// Set / Update Executive Scope
// ---------------------------------------------
const setCertificateExecutiveScope = (data) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/certificate/executive/scope/set/",
    data
  );
};

// ---------------------------------------------
// Get Executive Scope
// ---------------------------------------------
const getCertificateExecutiveScope = (agentId) => {
  const http = getAxiosInstance();

  return http.get(
    "/api/certificate/executive/scope/get/",
    {
      params: {
        agent_id: agentId,
      },
    }
  );
};

// ---------------------------------------------
// List Executive Scopes
// ---------------------------------------------
const getCertificateExecutiveScopeList = (params = {}) => {
  const http = getAxiosInstance();

  return http.get(
    "/api/certificate/executive/scope/list/",
    {
      params,
    }
  );
};

// ---------------------------------------------
// Get Protocol Format Options
// ---------------------------------------------
const getCertificateProtocolFormats = () => {
  const http = getAxiosInstance();

  return http.get(
    "/api/certificate/protocol-formats/"
  );
};

// =====================================================
// CERTIFICATE JOB QUEUE
// =====================================================


// -----------------------------------------------------
// Pending Jobs
// GET / POST
// -----------------------------------------------------

const getCertificatePendingJobs = (params = {}) => {
  const http = getAxiosInstance();

  return http.get(
    "/api/certificate/job/pending/",
    {
      params,
    }
  );
};


// -----------------------------------------------------
// Claim Job
// -----------------------------------------------------

const claimCertificateJob = (data) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/certificate/job/claim/",
    data
  );
};


// -----------------------------------------------------
// Job Detail
// GET
// -----------------------------------------------------

const getCertificateJobDetail = (jobId) => {
  const http = getAxiosInstance();

  return http.get(
    "/api/certificate/job/detail/",
    {
      params: {
        job_id: jobId,
      },
    }
  );
};


// -----------------------------------------------------
// Upload Certificate
// multipart/form-data
// -----------------------------------------------------

const uploadCertificateJobFile = (data) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/certificate/job/certificate/upload/",
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
};


// -----------------------------------------------------
// Submit Job
// -----------------------------------------------------

const submitCertificateJob = (data) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/certificate/job/submit/",
    data
  );
};


// -----------------------------------------------------
// My Assigned Jobs
// GET / POST
// -----------------------------------------------------

const getMyCertificateJobs = (params = {}) => {
  const http = getAxiosInstance();

  return http.get(
    "/api/certificate/job/mine/",
    {
      params,
    }
  );
};


// =====================================================
// SOS APIs
// =====================================================

const startCertificateJobSOS = (data) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/certificate/job/sos/start/",
    data
  );
};

const confirmCertificateJobSOSStart = (data) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/certificate/job/sos/start/confirm/",
    data
  );
};

const stopCertificateJobSOS = (data) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/certificate/job/sos/stop/",
    data
  );
};

const confirmCertificateJobSOSStop = (data) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/certificate/job/sos/stop/confirm/",
    data
  );
};


// =====================================================
// TRACKING
// =====================================================

const getCertificateJobTracking = (jobId) => {
  const http = getAxiosInstance();

  return http.get(
    "/api/certificate/job/tracking/",
    {
      params: {
        job_id: jobId,
      },
    }
  );
};



// =====================================================
// REVIEW QUEUE APIs
// =====================================================


// -----------------------------------------------------
// Review Queue
// GET / POST
// -----------------------------------------------------

const getCertificateReviewQueue = (params = {}) => {
  const http = getAxiosInstance();

  return http.get(
    "/api/certificate/job/review/list/",
    {
      params,
    }
  );
};


// -----------------------------------------------------
// Approve Job
// POST
// -----------------------------------------------------

const approveCertificateJob = (data) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/certificate/job/approve/",
    data
  );
};


// -----------------------------------------------------
// Reject Job
// POST
// -----------------------------------------------------

const rejectCertificateJob = (data) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/certificate/job/reject/",
    data
  );
};


// -----------------------------------------------------
// Reassign Job
// POST
// Superadmin / Certificate Admin
// -----------------------------------------------------

const reassignCertificateJob = (data) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/certificate/job/reassign/",
    data
  );
};


// -----------------------------------------------------
// Cancel Job
// POST
// Superadmin / Certificate Admin
// -----------------------------------------------------

const cancelCertificateJob = (data) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/certificate/job/cancel/",
    data
  );
};


// -----------------------------------------------------
// Pause Job
// POST
// Superadmin / Certificate Admin
// -----------------------------------------------------

const pauseCertificateJob = (data) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/certificate/job/pause/",
    data
  );
};


// -----------------------------------------------------
// Resume Job
// POST
// Superadmin / Certificate Admin
// -----------------------------------------------------

const resumeCertificateJob = (data) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/certificate/job/resume/",
    data
  );
};


// -----------------------------------------------------
// General Job List
// GET / POST
// -----------------------------------------------------

const getCertificateJobList = (params = {}) => {
  const http = getAxiosInstance();

  return http.get(
    "/api/certificate/job/list/",
    {
      params,
    }
  );
};


// -----------------------------------------------------
// Agent Performance
// GET
// -----------------------------------------------------

const getCertificateAgentPerformance = (params = {}) => {
  const http = getAxiosInstance();

  return http.get(
    "/api/certificate/job/agent-performance/",
    {
      params,
    }
  );
};
// Installed Jobs Certificate
const getInstalledCertificateJobs = (params = {}) => {
  const http = getAxiosInstance();

  return http.get("/api/certificate/job/stalled/list/", {
    params: {
      min_days: params.min_days ?? 2,
    },
  });
};


const resetInstalledCertificateJob = (data) => {
  const http = getAxiosInstance();

  return http.post("/api/certificate/job/stalled/reset/", data);
};

// -----------------------------------------------------
// Activation Command

// -----------------------------------------------------

const activateCertificateJob = (data) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/certificate/job/command/activate/",
    data
  );
};

// -----------------------------------------------------
// Reboot Command

// -----------------------------------------------------

const rebootCertificateJob = (data) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/certificate/job/command/reboot/",
    data
  );
};
const CertificateService = {
  createCertificateAdmin,
  createCertificateTeamLead,
  createCertificateTeamExecutive,
  updateCertificateAdmin,
  getCertificateAdminList,
  updateCertificateTeamLead,
  getCertificateTeamLeadList,
  updateCertificateExecutive,
  getCertificateExecutiveList,
  activateCertificateTeamMember,
  deactivateCertificateTeamMember,

  // Scope APIs
  setCertificateExecutiveScope,
  getCertificateExecutiveScope,
  getCertificateExecutiveScopeList,
  getCertificateProtocolFormats,

  // Job Queue
  getCertificatePendingJobs,
  claimCertificateJob,
  getCertificateJobDetail,
  uploadCertificateJobFile,
  submitCertificateJob,
  getMyCertificateJobs,

  // SOS
  startCertificateJobSOS,
  confirmCertificateJobSOSStart,
  stopCertificateJobSOS,
  confirmCertificateJobSOSStop,
  activateCertificateJob,
rebootCertificateJob,

  // Tracking
  getCertificateJobTracking,

  // Review Queue
  getCertificateReviewQueue,
  approveCertificateJob,
  rejectCertificateJob,
  reassignCertificateJob,
  cancelCertificateJob,
  pauseCertificateJob,
  resumeCertificateJob,

  // General Job List
  getCertificateJobList,

  // Agent Performance
  getCertificateAgentPerformance,
//Installed certificate
getInstalledCertificateJobs,
resetInstalledCertificateJob,
};

export default CertificateService;